var map = {
	"./5-Stars.svg": 223,
	"./Appstore.svg": 390,
	"./ArrowSquareOut.svg": 125,
	"./Bell.svg": 391,
	"./Bell2.svg": 392,
	"./ChartBar.svg": 126,
	"./InfoCircle.svg": 201,
	"./ListMagnifyingGlass.svg": 127,
	"./Logo-datazip.svg": 128,
	"./amazon-redshift.svg": 224,
	"./arrow-down.svg": 225,
	"./arrow-right-grey.svg": 393,
	"./arrow-right-tilted.svg": 394,
	"./arrow-right.svg": 203,
	"./arrow-up-white.svg": 211,
	"./availability.svg": 226,
	"./aws-white.svg": 206,
	"./aws.svg": 227,
	"./awsPermissions/2.svg": 395,
	"./awsPermissions/3.svg": 396,
	"./awsPermissions/4.svg": 397,
	"./awsPermissions/5.svg": 398,
	"./awsPermissions/6.svg": 399,
	"./awsPermissions/7.svg": 400,
	"./awsPermissions/8.svg": 401,
	"./awsPermissions/9.svg": 402,
	"./azure.svg": 205,
	"./bi/1.svg": 228,
	"./bi/2.svg": 229,
	"./bi/3.svg": 230,
	"./bi/4.svg": 231,
	"./bi/5.svg": 232,
	"./bi/6.svg": 233,
	"./bi_analysis.svg": 234,
	"./bi_data.svg": 235,
	"./bi_landing.svg": 236,
	"./bi_security.svg": 237,
	"./blog-image-1.svg": 129,
	"./blog-image-2.svg": 130,
	"./card.svg": 403,
	"./case_study.svg": 404,
	"./check-circle.svg": 238,
	"./check.svg": 202,
	"./click-to-copy.svg": 405,
	"./clickhouse.svg": 406,
	"./cloud-lock.svg": 407,
	"./cloud_native.svg": 408,
	"./configureDomain/1.svg": 239,
	"./configureDomain/2.svg": 240,
	"./cost-efficiency.svg": 241,
	"./create-stack.svg": 242,
	"./credit-card.svg": 243,
	"./cta-illustration.svg": 409,
	"./customization.svg": 244,
	"./data-analyst-feature-1.svg": 245,
	"./data-analyst-feature-2.svg": 246,
	"./data-analyst-feature-3.svg": 247,
	"./data-analyst-feature-tile-icon-01.svg": 248,
	"./data-analyst-feature-tile-icon-02.svg": 249,
	"./data-analyst-feature-tile-icon-03.svg": 250,
	"./data-analyst-main.svg": 251,
	"./data_analyst_use_case_1.svg": 252,
	"./data_analyst_use_case_2.svg": 253,
	"./data_analyst_use_case_3.svg": 254,
	"./data_analyst_use_case_4.svg": 255,
	"./datazip-footer-logo.svg": 131,
	"./datazip-icon.svg": 132,
	"./datazip-landing-image.svg": 256,
	"./datazip-logo-black.svg": 133,
	"./datazip-logo.svg": 410,
	"./datazip-text-logo.svg": 134,
	"./datazip.svg": 207,
	"./dbt.svg": 411,
	"./dep-lock.svg": 257,
	"./disclaimer.svg": 412,
	"./discord.svg": 413,
	"./docker.svg": 258,
	"./dollar.svg": 414,
	"./dzip-logo-black.svg": 415,
	"./dzip-logo-white.svg": 135,
	"./embed-analytic.svg": 259,
	"./exclamation-circle.svg": 260,
	"./eye.svg": 416,
	"./facebook.svg": 417,
	"./favicon.svg": 418,
	"./feature-2.svg": 419,
	"./feature-3.svg": 261,
	"./feature-4.svg": 262,
	"./feature-tile-icon-01.svg": 263,
	"./feature-tile-icon-02.svg": 420,
	"./feature-tile-icon-03.svg": 421,
	"./feature-tile-icon-04.svg": 422,
	"./feature-tile-icon-05.svg": 423,
	"./feature-tile-icon-06.svg": 424,
	"./features-bg-1.svg": 425,
	"./features-bg-2.svg": 426,
	"./file.svg": 264,
	"./finance-feature-1.svg": 265,
	"./finance-feature-2.svg": 266,
	"./finance-feature-3.svg": 267,
	"./finance-feature-tile-icon-01.svg": 268,
	"./finance-feature-tile-icon-02..svg": 427,
	"./finance-feature-tile-icon-02.svg": 269,
	"./finance-feature-tile-icon-03.svg": 270,
	"./finance-main.svg": 271,
	"./finance_use_case_1.svg": 272,
	"./finance_use_case_2.svg": 273,
	"./finance_use_case_3.svg": 274,
	"./finance_use_case_4.svg": 275,
	"./flatbread-banner-vector.svg": 428,
	"./flatbread-function-vector.svg": 429,
	"./flatbread-home.svg": 136,
	"./flatbread-logo.svg": 104,
	"./flatbread-nav-active.svg": 137,
	"./flatbread-nav-inactive.svg": 138,
	"./flatbread-product-1.svg": 139,
	"./flatbread-product-2.svg": 140,
	"./flatbread-product-3.svg": 141,
	"./flatbread-product-4.svg": 142,
	"./flatbread-product-5.svg": 143,
	"./g2_logo.svg": 276,
	"./g2_logo_back.svg": 430,
	"./gauge.svg": 144,
	"./get-started-bg.svg": 145,
	"./github-default.svg": 146,
	"./github-hover.svg": 431,
	"./github.svg": 105,
	"./globe.svg": 432,
	"./google.svg": 212,
	"./google_ads.svg": 433,
	"./google_cloud-white.svg": 208,
	"./google_cloud.svg": 277,
	"./grapes.svg": 278,
	"./green-tick.svg": 434,
	"./growpital.svg": 213,
	"./hand-shake.svg": 279,
	"./hero-image.svg": 435,
	"./hushl.svg": 280,
	"./iceberg-background.svg": 436,
	"./iceberg-logo.svg": 147,
	"./iceberg-transition-section-mobile.svg": 437,
	"./illustration-section-01.svg": 438,
	"./illustration-section-02.svg": 439,
	"./insight.svg": 440,
	"./instagram.svg": 148,
	"./intro-bg.svg": 441,
	"./intro-video-bottom.svg": 442,
	"./kenkohealth.svg": 281,
	"./key-challanges-bg.svg": 443,
	"./key.svg": 444,
	"./line-right-white.svg": 282,
	"./linkedin.svg": 149,
	"./logo.svg": 445,
	"./logo/aws-logo.svg": 283,
	"./logo/bigquery-logo.svg": 284,
	"./logo/code-logo.svg": 285,
	"./logo/datazip-logo.svg": 286,
	"./logo/dbt-logo.svg": 287,
	"./logo/fabric-logo.svg": 288,
	"./logo/fivetran-logo.svg": 214,
	"./logo/hevo-logo.svg": 289,
	"./logo/powerbi-logo.svg": 290,
	"./logo/segment-logo.svg": 291,
	"./logo/snowflake-logo.svg": 215,
	"./logo/tableau-logo.svg": 216,
	"./long-arrow-right-black.svg": 446,
	"./long-arrow-right.svg": 200,
	"./marker.svg": 292,
	"./marketing-feature-1.svg": 293,
	"./marketing-feature-2.svg": 294,
	"./marketing-feature-3.svg": 295,
	"./marketing-feature-tile-icon-01.svg": 296,
	"./marketing-feature-tile-icon-02.svg": 297,
	"./marketing-feature-tile-icon-03.svg": 298,
	"./marketing-main.svg": 299,
	"./marketing_use_case_1.svg": 300,
	"./marketing_use_case_2.svg": 301,
	"./marketing_use_case_3.svg": 302,
	"./marketing_use_case_4.svg": 303,
	"./medbikri.svg": 447,
	"./message.svg": 304,
	"./meteor.svg": 83,
	"./moengage.svg": 305,
	"./mongoDB.svg": 448,
	"./mysql.svg": 306,
	"./niroggyan.svg": 449,
	"./no_code.svg": 450,
	"./observability-background.svg": 451,
	"./olake-banner-vector.svg": 452,
	"./olake-benchmark-1.svg": 150,
	"./olake-benchmark-2.svg": 151,
	"./olake-byoc.svg": 152,
	"./olake-github.svg": 153,
	"./olake-home-mobile.svg": 154,
	"./olake-home.svg": 155,
	"./olake-logo-vector.svg": 156,
	"./olake-logo.svg": 157,
	"./olake-nav-active.svg": 158,
	"./olake-nav-inactive.svg": 159,
	"./olake-product-1.svg": 160,
	"./olake-product-2.svg": 161,
	"./olake-product-3.svg": 162,
	"./olake-product-4.svg": 453,
	"./olake-product-5.svg": 454,
	"./olake-product-6.svg": 455,
	"./olake-product-7.svg": 456,
	"./olake-saas.svg": 163,
	"./olake-section-background.svg": 457,
	"./one-stack-nav-active.svg": 164,
	"./one-stack-nav-inactive.svg": 165,
	"./onestack-logo.svg": 307,
	"./open-engine-graph1.svg": 458,
	"./openengine-intro-video-bg.svg": 308,
	"./openengine-video-1.svg": 309,
	"./openengine-video-2.svg": 310,
	"./openengine-video-3.svg": 459,
	"./operations-feature-1.svg": 311,
	"./operations-feature-2.svg": 312,
	"./operations-feature-3.svg": 313,
	"./operations-feature-tile-icon-01.svg": 314,
	"./operations-feature-tile-icon-02.svg": 315,
	"./operations-feature-tile-icon-03.svg": 316,
	"./operations-main.svg": 317,
	"./operations_use_case_1.svg": 318,
	"./operations_use_case_2.svg": 319,
	"./operations_use_case_3.svg": 320,
	"./operations_use_case_4.svg": 321,
	"./orange.svg": 322,
	"./pagarbook.svg": 209,
	"./people-1.svg": 323,
	"./people.svg": 324,
	"./pineapple.svg": 325,
	"./play-white.svg": 217,
	"./play.svg": 326,
	"./postgres.svg": 327,
	"./potential-1.svg": 166,
	"./potential-2.svg": 167,
	"./potential-3.svg": 168,
	"./potential-4.svg": 169,
	"./product-feature-1.svg": 328,
	"./product-feature-2.svg": 329,
	"./product-feature-3.svg": 330,
	"./product-feature-tile-icon-01.svg": 331,
	"./product-feature-tile-icon-02.svg": 332,
	"./product-feature-tile-icon-03.svg": 333,
	"./product-main.svg": 334,
	"./product_scale.svg": 335,
	"./product_secure.svg": 336,
	"./product_simplicity.svg": 337,
	"./product_use_case_1.svg": 338,
	"./product_use_case_2.svg": 339,
	"./product_use_case_3.svg": 340,
	"./product_use_case_4.svg": 341,
	"./qoute.svg": 460,
	"./question.svg": 342,
	"./replicate-mobile.svg": 461,
	"./resource-management.svg": 343,
	"./revenue-operations-feature-1.svg": 344,
	"./revenue-operations-feature-2.svg": 345,
	"./revenue-operations-feature-3.svg": 346,
	"./revenue-operations-feature-tile-icon-01.svg": 347,
	"./revenue-operations-feature-tile-icon-02.svg": 348,
	"./revenue-operations-feature-tile-icon-03.svg": 349,
	"./revenue-operations-main.svg": 350,
	"./revenue_ops_use_case_1.svg": 351,
	"./revenue_ops_use_case_2.svg": 352,
	"./revenue_ops_use_case_3.svg": 353,
	"./revenue_ops_use_case_4.svg": 354,
	"./rolling.svg": 355,
	"./s-grid.svg": 356,
	"./scalability.svg": 357,
	"./search.svg": 218,
	"./separation.svg": 358,
	"./settings.svg": 170,
	"./share-icon.svg": 359,
	"./signup-background.svg": 462,
	"./skyber.svg": 463,
	"./slack-default.svg": 171,
	"./slack-hover.svg": 464,
	"./smile.svg": 360,
	"./snowflake.svg": 361,
	"./speed-up-line.svg": 172,
	"./stepper.svg": 173,
	"./storage/1.svg": 362,
	"./storage/2.svg": 363,
	"./storage/3.svg": 364,
	"./storage/4.svg": 365,
	"./storage/5.svg": 366,
	"./storage/6.svg": 367,
	"./storage/7.svg": 368,
	"./storage/8.svg": 369,
	"./storage_landing.svg": 370,
	"./strawberry.svg": 371,
	"./stripe-logo.svg": 372,
	"./superset.svg": 465,
	"./topmate.svg": 466,
	"./twitter.svg": 174,
	"./use-case.svg": 373,
	"./use_case.svg": 467,
	"./vercel.svg": 468,
	"./vyapar.svg": 219,
	"./waitlist-bg.svg": 469,
	"./wallet-01.svg": 470,
	"./youtube.svg": 175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 389;